import styled from 'styled-components';

export default styled.div`
	min-height: 80vh;
	display: flex;
	justify-content: center;
	align-items: center;
`;
